import ko from '@tko/build.knockout';
import PermissionService from '../../../services/permission.service';
import templateMarkup from 'raw-loader!./share-widget.html';
import LoginService from "../../../services/login.service";
import DataProvider from "../../../app/data-framework/data-provider";

function ShareWidget(params) {

    var self = this;

    self.dataProvider = DataProvider.getInstance();
    self.permissionService = new PermissionService(LoginService.userObject);
    self.panels = params.panels;
    self.fixedPanels = params.fixedPanels;
    self.queryParams = params.queryParams;
    self.queryId = params.queryId;
    self.appId = params.appId;
    self.pdf = params.pdf;

    self.viewId = params.viewId;
    self.tabId = params.tabId; //observable
    self.shareName = params.shareName;
    self.frequencies = params.frequencies;
    self.reportingPeriods = params.reportingPeriods;
    self.reportingPeriodsOnce = params.reportingPeriodsOnce;
}

// This runs when the component is torn down. Put here any logic necessary to clean up,
// for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
ShareWidget.prototype.dispose = function () {
};

export default { viewModel: ShareWidget, template: templateMarkup };
